import { utils } from './utils'

export let socketUrl = process.env.REACT_APP_SOCKET_URL;
export let restUrl = process.env.REACT_APP_REST_URL;

export const minUsernameLength = 3;
export const maxLoggedOutUsernameLength = 6;
export const maxLoggedInUsernameLength = 12;

export const minNumPlayers = 2;
export const maxNumPlayers = 5;

export const maxGameTimerMode = 4;

export const boardTileSize = 256;

export const gameTimerModeNames = [ "Super Slow", "Slow", "Normal", "Fast", "Super Fast" ];

export const autoRefreshIntervalSeconds = parseInt( process.env.REACT_APP_AUTO_REFRESH_INTERVAL_SECONDS ) || 5;

export function getPlayerStandardIconPath( playerIconID, teamColourID )
{
  switch( playerIconID )
  {
    case 'bot':
      return getBotPlayerStandardIconPath( teamColourID );
    default:
      return getHumanPlayerStandardIconPath( teamColourID );
  }
};

export function getHumanPlayerStandardIconPath( teamColourID )
{
  return "/ui/Meeple - UI Circle - Player - " + utils.capitalizeFirstLetter( teamColourID ) + ".png"
};

export function getBotPlayerStandardIconPath( teamColourID )
{
  return "/ui/Meeple - UI Circle - BOT Opponent - " + utils.capitalizeFirstLetter( teamColourID ) + ".png"
};



export function getPlayerConsoleIconPath( playerIconID, teamColourID )
{
  switch( playerIconID )
  {
    case 'bot':
      return getBotPlayerConsoleIconPath( teamColourID );
    case 'spectator':
      return "/ui/spectator-icon.png";
    default:
      return getHumanPlayerConsoleIconPath( teamColourID );
  }
};

export function getHumanPlayerConsoleIconPath( teamColourID )
{
  return "./ui/Meeple - Console Icon - Player - " + utils.capitalizeFirstLetter( teamColourID ) + ".png"
};

export function getBotPlayerConsoleIconPath( teamColourID )
{
  return "./ui/Meeple - Console Icon - Bot - " + utils.capitalizeFirstLetter( teamColourID ) + ".png"
};
